import { render, staticRenderFns } from "./Statistics.component.html?vue&type=template&id=62ae964f&"
import script from "./Statistics.component.ts?vue&type=script&lang=ts&"
export * from "./Statistics.component.ts?vue&type=script&lang=ts&"
import style0 from "./Statistics.component.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports